<p-menubar [dt]="menubarHeaderDesignToken" [model]="navigationItems">
  <ng-template #start>
    <a [routerLink]="testAnalysisRoute" data-testid="header-home-link">
      <div class="title">Fenix Test Configurator</div>
    </a>
  </ng-template>
  <ng-template #end>
    <div class="end-items">
      @if (flagChips$ | async; as chips) {
        @for (chip of chips; track chip.label) {
          <span class="flag-chip">{{ chip.label }}: <strong>{{ chip.value }}</strong></span>
        }
      }
      <a href="#">
        <img class="traton-logo" alt="Traton logo" src="assets/logos/svg/TRATON_Logo_RGB_white.svg" />
      </a>
      <p-button raised="true" severity="secondary" variant="outlined" icon="pi pi-bars" (onClick)="menu.toggle($event)" data-testid="header-menu-button"></p-button>
    </div>
    <p-tieredmenu #menu [dt]="menuDesignToken" popup="true" [model]="menuItems$ | async" appendTo="body" (onShow)="onMenuShow()">
      <ng-template #item let-item>
        @let isDark = isDark$ | async;
        @if (item.id === 'darkMode') {
          <a class="p-tieredmenu-item-link dark-mode-link">
            <span [class]="'p-tieredmenu-item-icon pi ' + (isDark ? 'pi-moon' : 'pi-sun')"></span>
            <span class="p-tieredmenu-item-label">Theme</span>
            <p-toggleSwitch [ngModel]="isDark" styleClass="dark-mode-toggle" (click)="$event.stopPropagation()" (onChange)="themeService.toggleTheme()" data-testid="header-dark-mode-toggle">
              <ng-template pTemplate="themeSwitch">
                <i class="pi" [ngClass]="isDark ? 'pi-moon' : 'pi-sun'"></i>
              </ng-template>
            </p-toggleSwitch>
          </a>
        } @else if (item.id === 'user') {
          <a class="p-tieredmenu-item-link">
            <span [class]="'p-tieredmenu-item-icon ' + item.icon"></span>
            <span class="p-tieredmenu-item-label">{{ item.label }}</span>
          </a>
        } @else {
          <a class="p-tieredmenu-item-link" [pTooltip]="item.tooltip" tooltipPosition="top" tooltipStyleClass="menu-item-tooltip" [fitContent]="false">
            @if (item.icon) {
              <span [class]="'p-tieredmenu-item-icon ' + item.icon"></span>
            }
            <span class="p-tieredmenu-item-label">{{ item.label }}</span>
          </a>
        }
      </ng-template>
    </p-tieredmenu>

    @if (authService.userData$ | async; as userData) {
      @if (userData.sessionUID) {
        <p-drawer [dt]="drawerDesignToken" styleClass="user-details-drawer" header="User details" [(visible)]="showUserDetails" modal="true" position="right" closable="true" >
          <div class="drawer-content">
            <table class="user-table">
              @if (userData.firstName || userData.lastName) {
                <tr>
                  <td class="user-table-label">Name</td>
                  <td class="user-table-value">{{ userData.firstName }} {{ userData.lastName }}</td>
                </tr>
              }
              <tr>
                <td class="user-table-label">Company</td>
                <td class="user-table-value">{{ userData.companyName }}</td>
              </tr>
              <tr>
                <td class="user-table-label">Username</td>
                <td class="user-table-value">{{ userData.userName }}</td>
              </tr>
            </table>
            @if (userFunctionalGroups$ | async; as functionalGroups) {
              @if (functionalGroups.length) {
                <div class="functional-groups-title">
                  <b>Functional Groups</b>
                </div>
                @for (group of functionalGroups; track group.uid) {
                  <div class="functional-group-row">{{ group.name }}</div>
                }
              }
            }
          </div>
        </p-drawer>
      }
    }
    <!-- Privacy & data drawer: informational analytics notice, shared wording from the SDK -->
    <p-drawer [dt]="drawerDesignToken" styleClass="privacy-notice-drawer" header="Privacy & Data" [(visible)]="showPrivacyNotice" modal="true" position="right" closable="true">
      @if (privacyNotice; as notice) {
        <div class="privacy-notice">
          <h4>{{ notice.full.title }}</h4>
          <p>{{ notice.full.intro }}</p>
          @for (section of notice.full.sections; track section.title) {
            <section class="privacy-notice__section">
              <h5>{{ section.title }}</h5>
              <p>{{ section.body }}</p>
            </section>
          }
        </div>
      }
    </p-drawer>
    <!-- About dialog: build version generated by scripts/set-version.js -->
    <p-dialog header="Fenix Test Configurator" [(visible)]="showAbout" [modal]="true" [closable]="true" [dismissableMask]="true" appendTo="body"
              [breakpoints]="{'960px': '90vw', '640px': '95vw'}" [style]="{width: '450px'}">
      <div class="version-dialog-content">
        <table class="about-table">
          <tr>
            <td class="about-table-label">Version</td>
            <td>{{ appVersion.version }}</td>
          </tr>
          <tr>
            <td class="about-table-label">Released</td>
            <td>{{ appVersion.date }}</td>
          </tr>
          <tr>
            <td class="about-table-label">Commit</td>
            <td>{{ appVersion.commit }}</td>
          </tr>
          @for (flag of aboutFlags$ | async; track flag.label) {
            <tr>
              <td class="about-table-label">{{ flag.label }}</td>
              <td>{{ flag.value }}</td>
            </tr>
          }
        </table>
      </div>
    </p-dialog>
  </ng-template>
</p-menubar>
